import React from 'react';

import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS';
import { LabelSize } from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import {
  isBorderedVendorRequestStatus,
  VENDOR_REQUEST_STATUS_LABEL_VARIANT,
} from './VendorRequestStatusLabel.constants';

const VendorRequestStatusLabel = ({ status }) => (
  <LabelCDS
    size={LabelSize.M}
    title={status}
    variant={VENDOR_REQUEST_STATUS_LABEL_VARIANT[status]}
    withBorder={isBorderedVendorRequestStatus(status)}
  />
);

VendorRequestStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
};

export default VendorRequestStatusLabel;
